import { initCalendly } from "./calendly";
import { initVideo } from "./video";
import { initSlider } from "./slider";
import { initTabs } from "./tabs";
import { initFAQ } from "./faq";
import { initInformations } from "./informations";
import { initMovers } from "./libs/elementsmover/initMover";
import { initModals } from "./modal";
import { initScrollBoostBlock, initTeamDragScroll } from "./scroll";
import { initHeader } from "./header";
import { initCookie } from "./cookie";
import { initForms } from "./form";
import { initWidget } from "./widget";
import { initCopyLink } from "./link";
import { initShareButtons } from "./share";
import { initBlog } from "./blog";
import { initPhoneMask } from "./phoneMask";
import { initUTM } from "./utm";
import { initTextTruncate } from "./utils/utils";

interface ResizeHandler {
  (): void;
}

export async function init(): Promise<void> {
  initCalendly();
  initUTM();
  initVideo();
  initSlider();

  initTabs();
  initFAQ();
  initInformations();

  await initMovers();

  initScrollBoostBlock();
  initTeamDragScroll();
  initModals();

  initHeader();

  initCookie();
  initForms();
  initPhoneMask();
  initWidget();
  initCopyLink();

  initShareButtons();
  initBlog();

  if (document.querySelector("[data-truncate]")) {
    initTextTruncate();
  }
}

let resizeDebounce: ReturnType<typeof setTimeout> | undefined;

const handleResize: ResizeHandler = (): void => {
  clearTimeout(resizeDebounce);
  resizeDebounce = setTimeout(() => {
    initTextTruncate();
  }, 250);
};

window.addEventListener("resize", handleResize);
